import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'

import Login from '@/components/view/Login/login.vue'
import Index from '@/components/view/index'
import Custom from '@/components/view/customManager'
import User from '@/components/view/userManager'
import Role from '@/components/view/roleManager'
import EventList from '@/components/view/eventList'
import AppManager from '@/components/view/AppManager/appManager'
import h5Events from '@/components/view/h5Events'
import h5EventsList from '@/components/view/h5EventsList'
import GoogleAdList from '@/components/view/AdManager/googleAdList'
import strategyList from '@/components/view/AdManager/strategyListList'
import blacklist from '@/components/view/IpManager/blacklist'
import whiteList from '@/components/view/IpManager/whiteList'
import ipCount from '@/components/view/IpManager/ipCount'
import domainCount from '@/components/view/IpManager/domainCount'
import domainList from '@/components/view/domainManager/index'
import domainStatus from '@/components/view/domainManager/status'
import urlList from '@/components/view/AppManager/urlList'
import AppChannelManager from '@/components/view/AppManager/AppChannelManager'
import ApkList from '@/components/view/AppManager/ApkManager'
import GamManager from '@/components/view/GamManager/gamManager.vue'
import VideoManager from '@/components/view/videoManager/videoList.vue'
import CategoryManager from '@/components/view/videoManager/categoryList.vue'
import operationManager from '@/components/view/operationManager.vue'
import systemConsole from '@/components/view/systemConsole.vue'
import ipWhiteList from '@/components/view/IpManager/ipWhiteList.vue'
import Middleware from '@/components/view/middleware.vue'
import ArticleList from '@/components/view/ArticleManager/articleList.vue'
import UpdateTemplate from '@/components/view/ArticleManager/updateTemplate.vue'
import AIArticle from '@/components/view/ArticleManager/aiArticle.vue'
import ArticleCategoryList from '@/components/view/ArticleManager/categoryList.vue'
import addJson from '@/components/view/JsonManager/addJson.vue'
import checkJson from '@/components/view/JsonManager/checkJson.vue'
import reportIdManager from '@/components/view/GamManager/reportIdManager.vue'
import PorductManager from '@/components/view/ProductManager/index.vue'
import PlanList from '@/components/view/StripeManager/index.vue'
import NovelManager from '@/components/view/novelManager/novelList.vue'
import NovelCategoryManager from '@/components/view/novelManager/categoryList.vue'
import QuizList from '@/components/view/QuizManager/index.vue'
import QuizCategory from '@/components/view/QuizManager/categoryList.vue'
import AdsenseList from '@/components/view/AdsenseManager/AdsenseList.vue'
import VideoTemplate from '@/components/view/videoManager/videoTemplate.vue'
import TvVideoIndex from '@/components/view/TvVideoManager/index.vue'
import TvCategoryList from '@/components/view/TvVideoManager/videoCategory.vue'
import TvVideoDetail from '@/components/view/TvVideoManager/videoDetail.vue'
import TaskList from '@/components/view/taskManager/taskList.vue'
import DialList from '@/components/view/dialManager/dialList.vue'

// 静默捕获 router.push 的重复导航错误
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/Login',
    name: 'default',
    component: Login,
    hidden: true,
    id: 'login'
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    hidden: true,
    id: 'login'
  },

  {
    path: '/index',
    name: '首页',
    component: Home,
    iconCls: 'index',
    id: 26,
    children: [
      {
        path: '/index',
        name: '首页',
        component: Index
      }
    ]
  },

  // ==================== 业务管理 ====================
  {
    path: '/customManager',
    name: '客户管理',
    component: Home,
    iconCls: 'custom',
    id: 6,
    children: [
      {
        path: '/customManager',
        name: '客户',
        component: Custom
      }
    ]
  },
  {
    path: '/appManager',
    name: 'App管理',
    component: Home,
    iconCls: 'app',
    id: 1,
    children: [
      {
        path: '/appManager',
        name: 'App列表',
        component: AppManager
      },
      {
        path: '/appChannelManager',
        name: 'App渠道管理',
        component: AppChannelManager
      },
      {
        path: '/urlList',
        name: '渠道链接管理',
        component: urlList
      },
      {
        path: '/ApkList',
        name: 'App升级包',
        component: ApkList
      }
    ]
  },
  {
    path: '/userManager',
    name: '用户管理',
    component: Home,
    iconCls: 'config',
    id: 21,
    children: [
      {
        path: '/userManager',
        name: '用户',
        component: User
      }
    ]
  },
  {
    path: '/roleManager',
    name: '角色管理',
    component: Home,
    iconCls: 'role',
    id: 16,
    children: [
      {
        path: '/roleManager',
        name: '角色',
        component: Role
      }
    ]
  },
  {
    path: '/operationManager',
    name: '运营联系方式管理',
    component: Home,
    iconCls: 'lianxi',
    id: 16,
    children: [
      {
        path: '/operationManager',
        name: '联系方式',
        component: operationManager
      }
    ]
  },

  // ==================== 内容管理 ====================
  {
    path: '/videoManager',
    name: '短剧管理',
    component: Home,
    iconCls: 'short_video',
    id: 1,
    children: [
      {
        path: '/videoList',
        name: '短剧列表',
        component: VideoManager
      },
      {
        path: '/categoryList',
        name: '分类列表',
        component: CategoryManager
      },
      {
        path: '/videoTemplate',
        name: '短剧模板',
        component: VideoTemplate
      }
    ]
  },
  {
    path: '/TvVideoManager',
    name: 'Tv视频管理',
    component: Home,
    iconCls: 'video',
    id: 1,
    children: [
      {
        path: '/TvVideoIndex',
        name: '视频列表',
        component: TvVideoIndex
      },
      {
        path: '/TvCategoryList',
        name: '分类列表',
        component: TvCategoryList
      },
      {
        path: '/TvVideoDetail',
        name: '视频详情',
        component: TvVideoDetail
      }
    ]
  },
  {
    path: '/novelManager',
    name: '小说管理',
    component: Home,
    iconCls: 'novel',
    id: 1,
    children: [
      {
        path: '/novelList',
        name: '小说列表',
        component: NovelManager
      },
      {
        path: '/novelCategoryList',
        name: '分类列表',
        component: NovelCategoryManager
      }
    ]
  },
  {
    path: '/quizManager',
    name: 'Quiz管理',
    component: Home,
    iconCls: 'quiz',
    id: 1,
    children: [
      {
        path: '/quizList',
        name: 'Quiz列表',
        component: QuizList
      },
      {
        path: '/quizCategoryList',
        name: '分类列表',
        component: QuizCategory
      }
    ]
  },
  {
    path: '/ArticleManager',
    name: '文章管理',
    component: Home,
    iconCls: 'article',
    id: 16,
    children: [
      {
        path: '/ArticleCategoryList',
        name: '目录列表',
        component: ArticleCategoryList
      },
      {
        path: '/articleList',
        name: '文章列表',
        component: ArticleList
      },
      {
        path: '/updateTemplate',
        name: '文章模板',
        component: UpdateTemplate
      },
      {
        path: '/aiArticle',
        name: 'AI生成文章',
        component: AIArticle
      }
    ]
  },
  {
    path: '/addJson',
    name: 'JSON管理',
    component: Home,
    iconCls: 'json',
    id: 16,
    children: [
      {
        path: '/addJson',
        name: '添加JSON文件',
        component: addJson
      },
      {
        path: '/checkJson',
        name: '查看JSON文件',
        component: checkJson
      }
    ]
  },

  // ==================== 广告&事件 ====================
  {
    path: '/sdk_ad_manager',
    name: 'Sdk广告管理',
    component: Home,
    iconCls: 'sdk_ad_manager',
    id: 54,
    children: [
      {
        path: '/AdList',
        name: '广告列表',
        component: GoogleAdList
      },
      {
        path: '/strategyList',
        name: '策略列表',
        component: strategyList
      }
    ]
  },
  {
    path: '/AdsenseList',
    name: 'Adsense管理',
    component: Home,
    iconCls: 'adsense',
    id: 50,
    children: [
      {
        path: '/AdsenseList',
        name: 'Adsense列表',
        component: AdsenseList
      }
    ]
  },
  {
    path: '/GamManager',
    name: 'GAM管理',
    component: Home,
    iconCls: 'gam',
    id: 26,
    children: [
      {
        path: '/GamManager',
        name: 'GAM账号管理',
        component: GamManager
      }
    ]
  },
  {
    path: '/ReportId',
    name: 'ReportId管理',
    component: Home,
    iconCls: 'gam',
    hidden: true,
    id: 26,
    children: [
      {
        path: '/ReportId',
        name: 'GAM账号管理',
        component: reportIdManager
      }
    ]
  },
  {
    path: '/taskList',
    name: '任务管理',
    component: Home,
    iconCls: 'task',
    id: 27,
    children: [
      {
        path: '/taskList',
        name: '任务列表',
        component: TaskList
      }
    ]
  },
  {
    path: '/dialList',
    name: '表盘管理',
    component: Home,
    iconCls: 'dial',
    id: 28,
    children: [
      {
        path: '/dialList',
        name: '表盘列表',
        component: DialList
      }
    ]
  },
  {
    path: '/h5-events',
    name: 'H5 事件统计',
    component: Home,
    iconCls: 'h5_events',
    id: 25,
    children: [
      {
        path: '/h5-events',
        name: '事件趋势统计',
        component: h5Events
      }
    ]
  },
  {
    path: '/h5-eventsList',
    name: 'H5 事件列表',
    component: Home,
    iconCls: 'h5_list',
    id: 26,
    children: [
      {
        path: '/h5-eventsList',
        name: '事件列表',
        component: h5EventsList
      }
    ]
  },
  {
    path: '/eventList',
    name: '事件列表',
    component: Home,
    iconCls: 'event',
    id: 26,
    children: [
      {
        path: '/eventList',
        name: '事件',
        component: EventList
      }
    ]
  },

  // ==================== 域名&IP管理 ====================
  {
    path: '/domainManager',
    name: '域名管理',
    component: Home,
    iconCls: 'domain',
    id: 50,
    children: [
      {
        path: '/domainList',
        name: '域名列表',
        component: domainList
      },
      {
        path: '/domainStatus',
        name: '域名实时状态',
        component: domainStatus
      }
    ]
  },
  {
    path: '/IpManager',
    name: 'IP风险管理',
    component: Home,
    iconCls: 'ip',
    id: 70,
    children: [
      {
        path: '/ipCount',
        name: 'IP统计',
        component: ipCount
      },
      {
        path: '/blacklist',
        name: 'IP黑名单列表',
        component: blacklist,
        id: 71
      },
      {
        path: '/ipWhite',
        name: 'IP白名单列表',
        component: ipWhiteList,
        id: 71
      },
      {
        path: '/domainCount',
        name: '域名统计',
        component: domainCount,
        id: 73
      },
      {
        path: '/whiteList',
        name: '域名白名单列表',
        component: whiteList,
        id: 71
      }
    ]
  },

  // ==================== 系统管理 ====================
  {
    path: '/systemConsole',
    name: '系统日志',
    component: Home,
    iconCls: 'rizhi',
    id: 16,
    children: [
      {
        path: '/systemConsole',
        name: '系统日志',
        component: systemConsole
      }
    ]
  },
  {
    path: '/middleware',
    name: '中间链接管理',
    component: Home,
    iconCls: 'link',
    id: 16,
    children: [
      {
        path: '/middleware',
        name: '中间链接',
        component: Middleware
      }
    ]
  },

  // ==================== 其他 ====================
  {
    path: '/ProductManager',
    name: '产品管理',
    component: Home,
    iconCls: 'chanpin',
    id: 26,
    children: [
      {
        path: '/ProductManager',
        name: '产品管理',
        component: PorductManager
      }
    ]
  },
  {
    path: '/StripeManager',
    name: 'Stripe管理',
    component: Home,
    iconCls: 'stripe',
    id: 26,
    children: [
      {
        path: '/StripeManager',
        name: 'Plan列表',
        component: PlanList
      }
    ]
  }
]

export default new Router({
  routes,
  mode: 'history',
  base: '/enginingAds'
})



// WEBPACK FOOTER //
// ./src/router/index.js